var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08299 12.7594L7.01227 12.8301L7.08299 12.9008L10.3964 16.2142L10.3966 16.2144C10.7587 16.5744 11.3435 16.5744 11.7056 16.2144L11.7058 16.2142L15.0192 12.9008L15.0899 12.8301L15.0192 12.7594L13.8512 11.5914L13.7805 11.5207L13.7098 11.5914L11.9836 13.3176V5.61518V5.51518H11.8836H10.2269H10.1269V5.61518V13.3184L8.39223 11.5913L8.32152 11.5209L8.25096 11.5914L7.08299 12.7594ZM10.999 21.1C16.5771 21.1 21.099 16.5781 21.099 11C21.099 5.42192 16.5771 0.9 10.999 0.9C5.42095 0.9 0.899023 5.42192 0.899023 11C0.899023 16.5781 5.42095 21.1 10.999 21.1ZM19.3606 11C19.3606 15.618 15.617 19.3615 10.999 19.3615C6.38107 19.3615 2.63749 15.618 2.63749 11C2.63749 6.38205 6.38107 2.63846 10.999 2.63846C15.617 2.63846 19.3606 6.38205 19.3606 11Z",
    fill: "#A2A6AC",
    stroke: "#A2A6AC",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.999c840feeda946ecd1aba3cc2b2b537.svg";
export { ForwardRef as ReactComponent };